export default __webpack_public_path__ + "static/media/tips5.7f010712.png";